import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { fuelReceiptState } from './fuelReceiptState';
import { FuelReceiptState } from '../types';

export const fuelReceiptSlice = createSlice({
  name: 'fuelReceipts',
  initialState: fuelReceiptState,
  reducers: {
    setDataReset: () => fuelReceiptState,
    setVehicle(state, action: PayloadAction<FuelReceiptState['vehicle']>) {
      state.vehicle = action.payload;
    },
    setVehicleFilterMenuClosed(
      state,
      action: PayloadAction<FuelReceiptState['isVehicleFilterMenuClosed']>,
    ) {
      state.isVehicleFilterMenuClosed = action.payload;
    },
    setFuelType(state, action: PayloadAction<FuelReceiptState['fuelType']>) {
      state.fuelType = action.payload;
    },
    setDateRange(state, action: PayloadAction<FuelReceiptState['dateRange']>) {
      state.dateRange = action.payload;
    },
    setSortBy(state, action: PayloadAction<FuelReceiptState['sortBy']>) {
      state.sortBy = action.payload;
    },
    setSortField(state, action: PayloadAction<FuelReceiptState['sortField']>) {
      state.sortField = action.payload;
    },
    setRowsPerPage(state, action: PayloadAction<FuelReceiptState['limit']>) {
      state.limit = action.payload;
    },
    setPageIndex(state, action: PayloadAction<FuelReceiptState['offset']>) {
      state.offset = action.payload;
    },
    setTotalRecordCounts(
      state,
      action: PayloadAction<FuelReceiptState['totalRecordCount']>,
    ) {
      state.totalRecordCount = action.payload;
    },
    setFuelReceipts: (
      state,
      action: PayloadAction<FuelReceiptState['fuelReceipts']>,
    ) => {
      state.fuelReceipts = action.payload;
    },
    setFuelReceiptToEdit: (
      state,
      action: PayloadAction<FuelReceiptState['fuelReceiptToEdit']>,
    ) => {
      state.fuelReceiptToEdit = action.payload;
    },
    setFuelReceiptToDelete: (
      state,
      action: PayloadAction<FuelReceiptState['fuelReceiptToDelete']>,
    ) => {
      state.fuelReceiptToDelete = action.payload;
    },
    setFuelReceiptsReportData: (
      state,
      action: PayloadAction<FuelReceiptState['fuelReceiptsReportData']>,
    ) => {
      state.fuelReceiptsReportData = action.payload;
    },
    setDocumentType(
      state,
      action: PayloadAction<FuelReceiptState['documentType']>,
    ) {
      state.documentType = action.payload;
    },
    setExportDataRequestPendingTo(
      state,
      action: PayloadAction<FuelReceiptState['isExportDataRequestPending']>,
    ) {
      state.isExportDataRequestPending = action.payload;
    },
    setToggleUploadCsvModal(
      state,
      action: PayloadAction<FuelReceiptState['isToggleUploadCsvModal']>,
    ) {
      state.isToggleUploadCsvModal = action.payload;
    },
    setToggleExportFileModal(
      state,
      action: PayloadAction<FuelReceiptState['isToggleExportFileModal']>,
    ) {
      state.isToggleExportFileModal = action.payload;
    },
    setToggleDeleteFuelReceiptModal(
      state,
      action: PayloadAction<FuelReceiptState['isToggleDeleteFuelReceiptModal']>,
    ) {
      state.isToggleDeleteFuelReceiptModal = action.payload;
    },
    setToggleCreateEditFuelReceiptModal(
      state,
      action: PayloadAction<
        FuelReceiptState['isToggleCreateEditFuelReceiptModal']
      >,
    ) {
      state.isToggleCreateEditFuelReceiptModal = action.payload;
    },
    setToggleFuelReceiptBulkDownloadModal(
      state,
      action: PayloadAction<
        FuelReceiptState['isToggleFuelReceiptBulkDownloadModal']
      >,
    ) {
      state.isToggleFuelReceiptBulkDownloadModal = action.payload;
    },
    setResetData: () => fuelReceiptState,
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: fuelReceiptActions } = fuelReceiptSlice;

/* ------- STATE SELECTORS ------- */
export const selectFuelReceipts = (state: RootState) => state.fuelReceipts;

export default fuelReceiptSlice.reducer;
